export const defaultFormData = {
  user_id: "",
  mobile_no: "",
  Alt_mobile_no: "",
  PFirstName: "",
  PLastName: "",
  email: "",
  dateofbirth: "",
  PSex: "M",
  address: "",
  City: "",
  landmark: "",
  State: "West Bengal",
  Zipcode: "",
  preferredDate: "",
  preferredTime: "",
  Rtime: "",
  APPToTime: "",
  prescription: "",
  latitude: "",
  longitude: "",
  ref_doctorID: "",
  ref_doctor: "",
};
